import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n, useSession } from '@newtontechnologies/applib-frontend';
import { Button, Tooltip } from 'antd';
import { DownloadOutlined, FileTextOutlined, FileWordOutlined } from '@ant-design/icons';
import download from '../download';
const DownloadTranscription = ({ task, isReady, format }) => {
    const { connection } = useSession();
    const { intl } = useI18n();
    let icon;
    if (format === 'docx') {
        icon = _jsx(FileWordOutlined, {});
    }
    else if (format === 'txt') {
        icon = _jsx(FileTextOutlined, {});
    }
    else if (format === 'trsx') {
        icon = _jsx(DownloadOutlined, {});
    }
    return (_jsx(Tooltip, { title: intl.formatMessage({ id: `download${format.toUpperCase()}` }), children: _jsx(Button, { className: "task-btn", disabled: !isReady, shape: "circle", icon: icon, onClick: () => download(task.projectName, task.id, connection, format) }) }));
};
export default DownloadTranscription;
